"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f101 = void 0;
exports.f101 = {
    "et": [
        3,
        4,
        7,
        159,
        160,
        178,
        215,
        216,
        217,
        278,
        282,
        283,
        284,
        289,
        290,
        336,
        453,
        555,
        675,
        676,
        866,
        867,
        1136,
        1137,
        1141,
        1236,
        1237,
        1252,
        1598,
        1855,
        1950,
        1952,
        1964,
        1987,
        2024,
        2025,
        2306,
        2534,
        2535,
        2536,
        2537,
        2586,
        2587,
        2614,
        2616,
        2645,
        2698,
        2699,
        2728,
        2729,
        2780,
        2781,
        2811,
        2812,
        2844,
        2864,
        2886,
        2902,
        2903,
        2904,
        2919,
        2920,
        3039,
        3228,
        3404,
        3405,
        3495,
        3496,
        3529,
        3809,
        3922,
        3923,
        3982,
        3983,
        4100,
        4101,
        4107,
        4307,
        4339,
        4675,
        4676,
        4677,
        4678,
        4733,
        4981,
        4982,
        4988,
        4989,
        5148,
        5149,
        5174,
        5236,
        5243,
        5244,
        5245,
        5248,
        5601,
        5640,
        5900,
        5901,
        5902,
        6008,
        6502,
        6696,
        6825,
        6834,
        6868,
        6869,
        7020,
        7154,
        7179,
        7180,
        7196,
        7197,
        7286,
        7493,
        7494,
        7730,
        8158,
        8159,
        8256,
        8321,
        8355,
        8401,
        8581,
        8694,
        8993,
        8994,
        9179
    ],
    "ethiopia": [
        1236,
        1237,
        4107,
        4677,
        4678,
        3,
        4,
        7,
        159,
        160,
        178,
        215,
        216,
        217,
        278,
        282,
        283,
        284,
        289,
        290,
        336,
        453,
        555,
        675,
        676,
        866,
        867,
        1136,
        1137,
        1141,
        1252,
        1598,
        1855,
        1950,
        1952,
        1964,
        1987,
        2024,
        2025,
        2306,
        2534,
        2535,
        2536,
        2537,
        2586,
        2587,
        2614,
        2616,
        2645,
        2698,
        2699,
        2728,
        2729,
        2780,
        2781,
        2811,
        2812,
        2844,
        2864,
        2886,
        2902,
        2903,
        2904,
        2919,
        2920,
        3039,
        3228,
        3404,
        3405,
        3495,
        3496,
        3529,
        3809,
        3922,
        3923,
        3982,
        3983,
        4100,
        4101,
        4307,
        4339,
        4675,
        4676,
        4733,
        4981,
        4982,
        4988,
        4989,
        5148,
        5149,
        5174,
        5236,
        5243,
        5244,
        5245,
        5248,
        5601,
        5640,
        5900,
        5901,
        5902,
        6008,
        6502,
        6696,
        6825,
        6834,
        6868,
        6869,
        7020,
        7154,
        7179,
        7180,
        7196,
        7197,
        7286,
        7493,
        7494,
        7730,
        8158,
        8159,
        8256,
        8321,
        8355,
        8401,
        8581,
        8694,
        8993,
        8994,
        9179
    ],
    "er": [
        6,
        413,
        725,
        1284,
        1285,
        1893,
        2148,
        4029,
        5664,
        7153,
        7495,
        7499,
        7500
    ],
    "eritrea": [
        6,
        413,
        725,
        1284,
        1285,
        1893,
        2148,
        4029,
        5664,
        7153,
        7495,
        7499,
        7500
    ],
    "eranadans": [
        14
    ],
    "eastern": [
        2079,
        8109,
        23,
        72,
        126,
        537,
        602,
        793,
        1100,
        1101,
        1102,
        1412,
        1413,
        1414,
        1415,
        1416,
        1417,
        1418,
        1419,
        1420,
        1421,
        1485,
        1486,
        1487,
        1528,
        2053,
        2089,
        2105,
        2110,
        2113,
        2562,
        2810,
        2886,
        2976,
        2989,
        3178,
        3562,
        3676,
        3713,
        3714,
        3715,
        3716,
        3717,
        3912,
        4002,
        4552,
        4755,
        4756,
        4941,
        5139,
        5389,
        5449,
        5634,
        5987,
        6012,
        6013,
        6014,
        6015,
        6090,
        6107,
        6417,
        6800,
        7308,
        7309,
        7310,
        7450,
        8616,
        8809,
        9009,
        569,
        981,
        1017,
        1022,
        1049,
        1144,
        1150,
        1398,
        1399,
        1400,
        1447,
        1448,
        1608,
        1609,
        1612,
        1613,
        1760,
        1878,
        1879,
        1890,
        1922,
        1981,
        2008,
        2307,
        2393,
        2474,
        2479,
        2480,
        2815,
        2927,
        2986,
        3073,
        3104,
        3105,
        3481,
        3697,
        3762,
        4007,
        4009,
        4010,
        4012,
        4014,
        4177,
        4439,
        4471,
        4472,
        4587,
        4588,
        4589,
        4629,
        4799,
        4803,
        4810,
        4815,
        4918,
        5214,
        5224,
        5385,
        5386,
        5647,
        5669,
        5678,
        5994,
        6251,
        6299,
        6306,
        6512,
        6891,
        7182,
        7342,
        7418,
        7752,
        7881,
        7882,
        8024,
        8797,
        8834,
        8898,
        8941,
        8964,
        8992,
        9068,
        9125,
        9131,
        9132,
        9141,
        2647,
        3281,
        3718,
        5859,
        5860,
        6528,
        6560,
        8794
    ],
    "eastern abnaki": [
        23
    ],
    "ehie": [
        54
    ],
    "eyive": [
        54
    ],
    "eastern acipa": [
        72
    ],
    "ec": [
        79,
        512,
        1356,
        1565,
        1572,
        2058,
        2270,
        3376,
        5130,
        6395,
        6399,
        6401,
        6412,
        6419,
        6420,
        6429,
        6439,
        6444,
        6797,
        7410,
        9152
    ],
    "ecuador": [
        6424,
        2058,
        79,
        512,
        1356,
        1565,
        1572,
        2270,
        3376,
        5130,
        6395,
        6399,
        6401,
        6412,
        6419,
        6420,
        6429,
        6439,
        6444,
        6797,
        7410,
        9152
    ],
    "egypt": [
        2292,
        118,
        457,
        458,
        405,
        537,
        1574,
        1575,
        1576,
        2070,
        6888,
        8572,
        8573,
        8574
    ],
    "eg": [
        118,
        405,
        457,
        458,
        537,
        1574,
        1575,
        1576,
        2070,
        2292,
        6888,
        8572,
        8573,
        8574
    ],
    "eastern aranda": [
        126,
        569
    ],
    "eastern arrernte": [
        126
    ],
    "emirati arabic": [
        136
    ],
    "emirati": [
        136
    ],
    "ebe cluster": [
        138
    ],
    "ebe": [
        138,
        520
    ],
    "eloyi": [
        144
    ],
    "epe": [
        144
    ],
    "efutu": [
        148
    ],
    "east angal": [
        154
    ],
    "east": [
        1608,
        1609,
        1612,
        1613,
        1907,
        2474,
        2481,
        4393,
        4870,
        5905,
        7704,
        8108,
        8941,
        8998,
        154,
        610,
        2008,
        2557,
        2758,
        2986,
        3481,
        3721,
        5267,
        5546,
        5576,
        6581,
        6792,
        7687,
        7950,
        8265,
        8424,
        8555,
        8862,
        8991,
        495,
        4622,
        6481
    ],
    "esimbi": [
        168
    ],
    "eshimbi": [
        168
    ],
    "essimbi": [
        168
    ],
    "ed-eyng": [
        180,
        187
    ],
    "ezibo": [
        180,
        187
    ],
    "ejnu": [
        195
    ],
    "eynu": [
        195
    ],
    "english": [
        2118,
        2119,
        2120,
        2121,
        2122,
        2123,
        2124,
        2125,
        2126,
        2127,
        2128,
        2129,
        2130,
        2131,
        2132,
        2133,
        2134,
        2135,
        2136,
        2137,
        2138,
        2139,
        2140,
        2141,
        2142,
        2143,
        2144,
        2145,
        2146,
        2147,
        2148,
        2149,
        2150,
        2151,
        2152,
        2153,
        2154,
        2155,
        2156,
        2157,
        2158,
        2159,
        2160,
        2161,
        2162,
        2163,
        2164,
        2165,
        2166,
        2167,
        2168,
        2169,
        2170,
        2171,
        2172,
        2173,
        2174,
        2175,
        2176,
        2177,
        2178,
        2179,
        2180,
        2181,
        2182,
        2183,
        2184,
        2185,
        2186,
        2187,
        2188,
        2189,
        2190,
        2191,
        2192,
        2193,
        2194,
        2195,
        2196,
        2197,
        2198,
        2199,
        2200,
        2201,
        2202,
        2203,
        2204,
        2205,
        2206,
        2207,
        2208,
        2209,
        2210,
        2211,
        2212,
        2213,
        2214,
        2215,
        2216,
        2217,
        2218,
        2219,
        2220,
        2221,
        2222,
        2223,
        2224,
        2225,
        2226,
        200,
        321,
        616,
        1306,
        1307,
        1588,
        2234,
        2569,
        2754,
        2813,
        2866,
        3130,
        3315,
        4340,
        7217,
        7362,
        7452,
        7705,
        8081,
        6544,
        877,
        1035,
        2416,
        3102,
        6077,
        6149,
        7113,
        7371,
        7666,
        8212
    ],
    "eibela": [
        206
    ],
    "eighon": [
        218
    ],
    "ekware": [
        234
    ],
    "elege": [
        262
    ],
    "eru": [
        279
    ],
    "emmi": [
        312,
        9098
    ],
    "es": [
        314,
        478,
        1323,
        1327,
        1631,
        2256,
        2262,
        2268,
        2316,
        2324,
        2346,
        2674,
        2706,
        5213,
        5976,
        6408,
        6558,
        7144,
        8141,
        8389,
        8687
    ],
    "eyan": [
        339
    ],
    "enen": [
        348
    ],
    "enindhilyagwa": [
        352
    ],
    "enindiljaugwa": [
        352
    ],
    "eylandt": [
        352
    ],
    "edimala": [
        400
    ],
    "enenlhet": [
        403
    ],
    "emirates": [
        407,
        2121,
        7136
    ],
    "eh": [
        412
    ],
    "egyptian": [
        2070,
        2292,
        457,
        458,
        537,
        582
    ],
    "egyptian arabic": [
        457,
        458
    ],
    "etoh": [
        498
    ],
    "eastern egyptian bedawi arabic": [
        537
    ],
    "edera": [
        564
    ],
    "edera awyu": [
        564
    ],
    "ebadu": [
        576
    ],
    "eastern durango aztec": [
        602
    ],
    "eastern durango nahuatl": [
        602
    ],
    "este": [
        602,
        603,
        604,
        3075,
        3097,
        4581,
        4810,
        6417,
        8648
    ],
    "en": [
        2229,
        5264,
        8117,
        605,
        8141
    ],
    "east choiseul": [
        610
    ],
    "elomay": [
        611,
        684
    ],
    "elunay": [
        611,
        684
    ],
    "efu": [
        637
    ],
    "ewota": [
        657
    ],
    "era": [
        666
    ],
    "ekpali": [
        672
    ],
    "ediba": [
        678
    ],
    "ekumuru": [
        678
    ],
    "emberá-baudó": [
        687
    ],
    "embena": [
        687,
        1532,
        1668,
        2109,
        6889,
        7385
    ],
    "embera": [
        2109,
        687,
        1532,
        1668,
        6889,
        7385
    ],
    "epena": [
        6889,
        687,
        1532,
        1668,
        2109,
        7385
    ],
    "e": [
        2063,
        692,
        6672,
        7077
    ],
    "ekibene": [
        740
    ],
    "ekibena": [
        740
    ],
    "ewâmnèə mə̂yn": [
        755
    ],
    "ewâmnèə": [
        755
    ],
    "erankad": [
        769,
        770
    ],
    "eastern balochi": [
        793
    ],
    "eastern hill balochi": [
        793
    ],
    "ebhele": [
        834
    ],
    "edo": [
        847,
        5875,
        5889
    ],
    "ebila": [
        849
    ],
    "ebuja": [
        859
    ],
    "embudja": [
        859
    ],
    "ebekwara": [
        906
    ],
    "ebeembe": [
        945
    ],
    "ebembe": [
        945
    ],
    "equatorial guinea": [
        979,
        984,
        1197,
        1250,
        2271,
        2332,
        2342,
        2416,
        2439,
        5568,
        5732,
        6333
    ],
    "equatorial": [
        2416,
        2342,
        979,
        984,
        1197,
        1250,
        2271,
        2332,
        2439,
        5568,
        5732,
        6333
    ],
    "eastern tawbuid": [
        981
    ],
    "edwas": [
        992
    ],
    "eastern bororo": [
        1017
    ],
    "eastern bobo oule": [
        1022
    ],
    "eastern bobo wule": [
        1022
    ],
    "eastern rote": [
        1049,
        6512
    ],
    "eegima": [
        1059
    ],
    "eegimaa": [
        1059
    ],
    "endungo": [
        1059
    ],
    "ezik": [
        1063
    ],
    "ehob mkaa": [
        1075
    ],
    "ehob": [
        1075
    ],
    "ende": [
        2230,
        1098,
        4486
    ],
    "eastern bru": [
        1100,
        1101,
        1102
    ],
    "eastern bwatiye": [
        1144
    ],
    "eastern bété": [
        1150
    ],
    "ebudu": [
        1190
    ],
    "eviia": [
        1192
    ],
    "ediya": [
        1197
    ],
    "evant": [
        1322
    ],
    "evand": [
        1322
    ],
    "ette ennaka": [
        1355
    ],
    "ette": [
        1355
    ],
    "ennaka": [
        1355
    ],
    "ette taara": [
        1355
    ],
    "ede cabe": [
        1357
    ],
    "ede": [
        1357,
        3127,
        3137,
        3174,
        5653,
        3147,
        3148,
        5652,
        7831,
        8493
    ],
    "ede-cabε": [
        1357
    ],
    "el salvador": [
        1385,
        2282,
        2294,
        6271
    ],
    "el": [
        2095,
        2099,
        1615,
        4798,
        9135,
        2294,
        4704,
        4705,
        5226,
        1385,
        2282,
        6271
    ],
    "eastern fujian": [
        1398,
        1399,
        1400
    ],
    "eastern min": [
        1398,
        1399,
        1400
    ],
    "eastern khumi chin": [
        1412
    ],
    "ekai": [
        1424
    ],
    "ekai chin": [
        1424
    ],
    "eastern mari": [
        1447,
        1448
    ],
    "echuabo": [
        1458
    ],
    "echuwabo": [
        1458
    ],
    "echuwabu": [
        1458
    ],
    "ecwabo": [
        1458
    ],
    "etxuwabo": [
        1458
    ],
    "eastern cham": [
        1485,
        1486,
        1487
    ],
    "eastern highland chatino": [
        1528
    ],
    "emberá-chamí": [
        1532
    ],
    "emberá": [
        2109,
        6889,
        1532,
        1668
    ],
    "eastern james bay cree southern dialect": [
        1608,
        1609
    ],
    "east cree": [
        1612,
        1613
    ],
    "east main cree": [
        1612,
        1613
    ],
    "eastern james bay cree northern dialect": [
        1612,
        1613
    ],
    "el nayar cora": [
        1615
    ],
    "eklenjuy": [
        1620
    ],
    "emberá-catío": [
        1668
    ],
    "emberá-katío": [
        1668
    ],
    "epera": [
        1668,
        6889
    ],
    "epẽrã": [
        1668
    ],
    "eyabida": [
        1668
    ],
    "ekikabhwa": [
        1703
    ],
    "ekikabwa": [
        1703
    ],
    "elebo": [
        1747
    ],
    "edopi": [
        1751
    ],
    "elopi": [
        1751
    ],
    "eraans": [
        1754,
        1755
    ],
    "esaro": [
        1758
    ],
    "eastern bade": [
        1760
    ],
    "evji": [
        1760
    ],
    "esclave du sud": [
        1804,
        1805
    ],
    "esclave": [
        1804,
        1805,
        6734,
        6735
    ],
    "eastern maroon creole": [
        1878,
        1879
    ],
    "eastern dinka": [
        1890
    ],
    "east damar": [
        1907
    ],
    "eastern duun": [
        1922
    ],
    "eastern kadazan": [
        1981
    ],
    "east cagayan negrito": [
        2008
    ],
    "eastern cagayan agta": [
        2008
    ],
    "eastern cagayan dumagat": [
        2008
    ],
    "ebughu": [
        2052
    ],
    "eastern bontoc": [
        2053
    ],
    "eastern bontok": [
        2053
    ],
    "eboo teke": [
        2054
    ],
    "eboo": [
        2054
    ],
    "eboom": [
        2054
    ],
    "ebrié": [
        2055
    ],
    "embo": [
        2056
    ],
    "embu": [
        2056
    ],
    "eteocretan": [
        2057
    ],
    "ecuadorian sign language": [
        2058
    ],
    "ecuadorian": [
        2058
    ],
    "eteocypriot": [
        2059
    ],
    "eʋegbe": [
        2060,
        2062
    ],
    "ebwe": [
        2060,
        2061
    ],
    "efe": [
        2065,
        2060,
        2061
    ],
    "ehwe": [
        2060,
        2061
    ],
    "eibe": [
        2060,
        2061
    ],
    "eue": [
        2060,
        2061
    ],
    "eve": [
        2060,
        2061
    ],
    "ewe": [
        2062,
        2060,
        2061
    ],
    "e hwen": [
        2063
    ],
    "e xwen": [
        2063
    ],
    "ea": [
        2063,
        2269
    ],
    "eahua": [
        2063
    ],
    "ei": [
        2063
    ],
    "efai": [
        2064
    ],
    "effiat": [
        2064
    ],
    "efik": [
        2066
    ],
    "ega": [
        2067
    ],
    "egwa": [
        2067
    ],
    "emilian": [
        2068
    ],
    "emigliân": [
        2068
    ],
    "eggon": [
        2069
    ],
    "egon": [
        2069
    ],
    "egyptian (ancient)": [
        2070
    ],
    "ehime oshima shuwa": [
        2071
    ],
    "ehime": [
        2071
    ],
    "ehime-oshima sign language": [
        2071
    ],
    "ehime-oshima": [
        2071
    ],
    "ehueun": [
        2072
    ],
    "ekpenmen": [
        2072,
        7941
    ],
    "ekpimi": [
        2072
    ],
    "epimi": [
        2072
    ],
    "eipo": [
        2073
    ],
    "eipomek": [
        2073
    ],
    "eitiep": [
        2074
    ],
    "eivo": [
        2075,
        6000
    ],
    "eiwo": [
        2075
    ],
    "ediamat": [
        2076
    ],
    "ejamat": [
        2076
    ],
    "ekajuk": [
        2077,
        2078
    ],
    "eastern karnic": [
        2079
    ],
    "ekit": [
        2080
    ],
    "eket": [
        2080
    ],
    "ekid": [
        2080
    ],
    "ekari": [
        2081
    ],
    "ekagi": [
        2081
    ],
    "eki": [
        2082
    ],
    "elip": [
        2084
    ],
    "ekoti": [
        2085,
        2086
    ],
    "ekpeye": [
        2087
    ],
    "ekkpahia": [
        2087
    ],
    "ekpabya": [
        2087
    ],
    "ekpaffia": [
        2087
    ],
    "ekpari": [
        2088
    ],
    "eastern kayah": [
        2089
    ],
    "elepi": [
        2094
    ],
    "el hugeirat": [
        2095
    ],
    "el hagarat": [
        2095
    ],
    "eliri": [
        2096
    ],
    "elkei": [
        2097
    ],
    "eleme": [
        2098
    ],
    "el molo": [
        2099
    ],
    "elmolo": [
        2099
    ],
    "elu": [
        2100
    ],
    "elle": [
        2100
    ],
    "ere": [
        7831,
        2100,
        2252,
        7992
    ],
    "elamite": [
        2101
    ],
    "emai-iuleha-ora": [
        2102
    ],
    "embaloh": [
        2103
    ],
    "emereñon": [
        2104
    ],
    "emerillon": [
        2104
    ],
    "emerilon": [
        2104
    ],
    "eastern meohang": [
        2105
    ],
    "emira": [
        2106
    ],
    "emira-mussau": [
        2106
    ],
    "eman": [
        2108
    ],
    "emane": [
        2108
    ],
    "emberá, northern": [
        2109
    ],
    "ebera bedea": [
        2109
    ],
    "ebera": [
        2109
    ],
    "eberã": [
        2109
    ],
    "eberã bed’ea": [
        2109
    ],
    "empera": [
        2109,
        6889
    ],
    "emperã": [
        2109
    ],
    "eperã pedea": [
        2109
    ],
    "eperã": [
        2109
    ],
    "epérã pedée": [
        2109
    ],
    "epérã": [
        2109
    ],
    "epenã": [
        2109
    ],
    "eastern minyag": [
        2110
    ],
    "eskimo": [
        2291,
        3177,
        2111,
        2112,
        2297,
        2298,
        2299,
        8911
    ],
    "eastern muria": [
        2113
    ],
    "emplawas": [
        2114
    ],
    "erromintxela": [
        2115
    ],
    "errominchela": [
        2115
    ],
    "errumantxela": [
        2115
    ],
    "euskado-romani": [
        2115
    ],
    "euskado-rromani": [
        2115
    ],
    "epigraphic mayan": [
        2116
    ],
    "epigraphic": [
        2116
    ],
    "engels": [
        2118,
        2134,
        2146,
        2210
    ],
    "engelsk": [
        2118,
        2134,
        2146,
        2210
    ],
    "engelska": [
        2118,
        2134,
        2146,
        2210
    ],
    "engelski": [
        2118,
        2146,
        2210
    ],
    "englaisa": [
        2118,
        2134,
        2146,
        2210
    ],
    "englanti": [
        2118,
        2134,
        2146,
        2210
    ],
    "englesch": [
        2118,
        2134,
        2146,
        2210
    ],
    "engleză": [
        2118,
        2134,
        2146,
        2210
    ],
    "englisch": [
        2118,
        2134,
        2146,
        2210
    ],
    "europe": [
        2120
    ],
    "emerum": [
        2227
    ],
    "endeh": [
        2230
    ],
    "enets, forest": [
        2231
    ],
    "enets": [
        2231,
        2232
    ],
    "enets, tundra": [
        2232
    ],
    "enlhet": [
        2233
    ],
    "eenlhit": [
        2233
    ],
    "enlhet norte": [
        2233
    ],
    "enlhet-lengua": [
        2233
    ],
    "enslet": [
        2233
    ],
    "enthlit": [
        2233
    ],
    "engenni": [
        2235
    ],
    "egene": [
        2235
    ],
    "enggano": [
        2236
    ],
    "engganese": [
        2236
    ],
    "enga": [
        2237,
        4134
    ],
    "eŋa": [
        2237,
        4134
    ],
    "emem": [
        2238
    ],
    "emumu": [
        2238
    ],
    "enu": [
        2239
    ],
    "enwan": [
        2240,
        2241
    ],
    "enwan (edu state)": [
        2240
    ],
    "edu": [
        2240
    ],
    "enwan (akwa ibom state)": [
        2241
    ],
    "enwang": [
        2241
    ],
    "enxet": [
        2242
    ],
    "enxet sur": [
        2242
    ],
    "esperanto": [
        2243
    ],
    "eotile": [
        2244
    ],
    "epie": [
        2245
    ],
    "epie-atissa": [
        2245
    ],
    "eravallan": [
        2246
    ],
    "eromanga": [
        2247
    ],
    "eromangan": [
        2247
    ],
    "erramanga": [
        2247
    ],
    "erromanga": [
        2247
    ],
    "erromangan": [
        2247
    ],
    "eromaga": [
        2247
    ],
    "eruwa": [
        2248
    ],
    "erakwa": [
        2248
    ],
    "erohwa": [
        2248
    ],
    "erima": [
        2249
    ],
    "efate, south": [
        2250
    ],
    "efate": [
        2250,
        4388,
        2307
    ],
    "erakor": [
        2250
    ],
    "ergong": [
        2251
    ],
    "erre": [
        2252
    ],
    "ersu": [
        2253
    ],
    "erhsu": [
        2253
    ],
    "eritai": [
        2254
    ],
    "editode edai": [
        2254
    ],
    "editode": [
        2254
    ],
    "edai": [
        2254
    ],
    "erai": [
        2254,
        3203
    ],
    "eri": [
        2254
    ],
    "erokwanas": [
        2255
    ],
    "español de españa": [
        2256
    ],
    "español": [
        2256,
        2257,
        2258,
        2259,
        2260,
        2261,
        2263,
        2264,
        2265,
        2266,
        2267,
        2269,
        2270,
        2271,
        2272,
        2273,
        2274,
        2275,
        2276,
        2277,
        2278,
        2279,
        2280,
        2281,
        2282,
        2283,
        2284,
        2285,
        2262,
        2268,
        4189,
        4190,
        4191
    ],
    "españa": [
        2256
    ],
    "espagnol": [
        2256,
        2262,
        2268
    ],
    "español latinoamericano": [
        2257
    ],
    "español de méxico": [
        2275
    ],
    "ese ejja": [
        2286
    ],
    "ese": [
        2286,
        4641
    ],
    "ejja": [
        2286
    ],
    "eseꞌejja": [
        2286
    ],
    "ese eja": [
        2286
    ],
    "eja": [
        2286
    ],
    "ese exa": [
        2286
    ],
    "exa": [
        2286
    ],
    "eseejja": [
        2286
    ],
    "ese’eha": [
        2286
    ],
    "ese’ejja": [
        2286
    ],
    "essejja": [
        2286
    ],
    "eshtehardi": [
        2290
    ],
    "egyptian sign language": [
        2292
    ],
    "esl": [
        2292
    ],
    "egypt sign language": [
        2292
    ],
    "esuma": [
        2293
    ],
    "el salvadoran sign language": [
        2294
    ],
    "estonian sign language": [
        2295
    ],
    "estonian": [
        2295,
        2302,
        2303
    ],
    "evk": [
        2295
    ],
    "eesti viipekeel": [
        2295
    ],
    "eesti": [
        2302,
        2295
    ],
    "ee": [
        2295,
        2302,
        2303,
        8136
    ],
    "estonia": [
        2295,
        2302,
        2303,
        8136
    ],
    "esselen": [
        2296
    ],
    "eskayan": [
        2300,
        2301
    ],
    "eskaya’": [
        2300,
        2301
    ],
    "eesti keel": [
        2302
    ],
    "eesti kirjakeel": [
        2302
    ],
    "estonian, standard": [
        2302
    ],
    "etebi": [
        2304
    ],
    "etchemin": [
        2305
    ],
    "ethiopian sign language": [
        2306
    ],
    "ethiopian": [
        2306
    ],
    "eton": [
        2307,
        2308
    ],
    "eastern efate": [
        2307
    ],
    "epwau": [
        2307
    ],
    "eton (vanuatu)": [
        2307
    ],
    "eton (cameroon)": [
        2308
    ],
    "edolo": [
        2309
    ],
    "edolo ado": [
        2309
    ],
    "etolo": [
        2309
    ],
    "etoro": [
        2309
    ],
    "etsako": [
        2310
    ],
    "etsakor": [
        2310
    ],
    "etruscan": [
        2311,
        2312
    ],
    "ejagham": [
        2313
    ],
    "edjagam": [
        2313
    ],
    "ejagam": [
        2313
    ],
    "ejaham": [
        2313
    ],
    "ejwe": [
        2313
    ],
    "ekoi": [
        2313
    ],
    "etung": [
        2313
    ],
    "eten": [
        2314
    ],
    "etien": [
        2314
    ],
    "etna bay": [
        2315
    ],
    "etna": [
        2315
    ],
    "euskara": [
        2316
    ],
    "euska": [
        2316
    ],
    "euskera": [
        2316
    ],
    "euskerie": [
        2316
    ],
    "even": [
        2317,
        2318
    ],
    "eben": [
        2317,
        2318
    ],
    "ewen": [
        2317,
        2318
    ],
    "effurun": [
        2319
    ],
    "evrie": [
        2319
    ],
    "evenki": [
        2320,
        2321,
        2322
    ],
    "ewenk": [
        2320,
        2321,
        2322
    ],
    "ewenke": [
        2320,
        2321,
        2322
    ],
    "ewenki": [
        2320,
        2321,
        2322
    ],
    "ewondo": [
        2323
    ],
    "ewundu": [
        2323
    ],
    "extremaduran": [
        2324
    ],
    "ehtremeñu": [
        2324
    ],
    "extremeño": [
        2324
    ],
    "eyak": [
        2325
    ],
    "elgeyo": [
        2326
    ],
    "ezaa": [
        2327
    ],
    "eza": [
        2327
    ],
    "ezza": [
        2327
    ],
    "ezekwe": [
        2328
    ],
    "eastern fijian": [
        2393
    ],
    "equatorial guinean pidgin": [
        2416
    ],
    "ecuatorial": [
        2416
    ],
    "eastern frisian": [
        2474
    ],
    "eastern fulani": [
        2479,
        2480
    ],
    "eastern fulfulde": [
        2479,
        2480
    ],
    "east futuna": [
        2481
    ],
    "east futunan": [
        2481
    ],
    "erronan": [
        2495
    ],
    "erse": [
        2504,
        2505,
        2506
    ],
    "east gwari": [
        2557
    ],
    "eastern xwla gbe": [
        2562
    ],
    "engarilla": [
        2566
    ],
    "eugoola": [
        2566
    ],
    "eviya": [
        2610
    ],
    "evia": [
        2610
    ],
    "enya": [
        2613
    ],
    "ena": [
        2613,
        3104,
        3105
    ],
    "east paraná": [
        2758
    ],
    "equinao": [
        2758
    ],
    "equiniquinao": [
        2758
    ],
    "elleniké noematiké glossa": [
        2794
    ],
    "elleniké": [
        2794
    ],
    "elsaessisch": [
        2795,
        2796
    ],
    "eastern bolivian guaraní": [
        2810
    ],
    "eastern argentina guaraní": [
        2815
    ],
    "egun": [
        2823
    ],
    "ekegusii": [
        2825
    ],
    "em": [
        2858
    ],
    "eastern oromo": [
        2886
    ],
    "ekihaya": [
        2909
    ],
    "ekihâya": [
        2909
    ],
    "ebang": [
        2913
    ],
    "ehe": [
        2925
    ],
    "ekiehe": [
        2925
    ],
    "eastern luba": [
        2927
    ],
    "emba": [
        2927
    ],
    "eastern huishui hmong": [
        2976
    ],
    "eastern huishui miao": [
        2976
    ],
    "east guizhou miao": [
        2986
    ],
    "eastern guizhou hmu": [
        2986
    ],
    "eastern east-guizhou miao": [
        2989
    ],
    "east-guizhou": [
        2989,
        2991
    ],
    "eastern hmu": [
        2989
    ],
    "eastern qiandong miao": [
        2989
    ],
    "eastern ‡hoan": [
        3073
    ],
    "enzeb": [
        3095
    ],
    "eastern armenian": [
        3104,
        3105
    ],
    "ermeni dili": [
        3104,
        3105
    ],
    "ermeni": [
        3104,
        3105
    ],
    "ermenice": [
        3104,
        3105
    ],
    "erâmani": [
        3104,
        3105
    ],
    "evorra": [
        3114
    ],
    "eiwaja": [
        3117
    ],
    "ede ica": [
        3127
    ],
    "etkywan": [
        3128
    ],
    "etekwe": [
        3128
    ],
    "ede idaca": [
        3137
    ],
    "ede ife": [
        3147,
        3148
    ],
    "ebo": [
        3154
    ],
    "ebira": [
        3155
    ],
    "egbira": [
        3155
    ],
    "egbura": [
        3155
    ],
    "egedde": [
        3156
    ],
    "egede": [
        3156
    ],
    "ezon": [
        3172
    ],
    "ede ije": [
        3174
    ],
    "ede-ijε": [
        3174
    ],
    "eastern canadian inuktitut": [
        3178
    ],
    "ekpeshe": [
        3183
    ],
    "ekhwa": [
        3188
    ],
    "epai": [
        3232
    ],
    "erokh": [
        3238
    ],
    "erukala": [
        3241,
        3242,
        8778
    ],
    "esan": [
        3251
    ],
    "esa": [
        3251
    ],
    "eshkashimi": [
        3253
    ],
    "ewmien": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "ezzi": [
        3301
    ],
    "enku": [
        3320
    ],
    "echijita": [
        3374
    ],
    "ecijiita": [
        3374
    ],
    "ecijita": [
        3374
    ],
    "eeleeree": [
        3431
    ],
    "eura": [
        3431
    ],
    "ejiwajegi": [
        3480
    ],
    "ediu-adig": [
        3480
    ],
    "ejiwajigi": [
        3480
    ],
    "eyiguayegi": [
        3480
    ],
    "east circassian": [
        3481
    ],
    "eastern adyghe": [
        3481
    ],
    "eastern circassian": [
        3481
    ],
    "enkelembu": [
        3509,
        3648,
        4118
    ],
    "ecikerebe": [
        3561
    ],
    "ekikerebe": [
        3561
    ],
    "eastern keres": [
        3562
    ],
    "eastern keres pueblo": [
        3562
    ],
    "evav": [
        3566
    ],
    "ema": [
        3570,
        8964
    ],
    "ekpeebhe": [
        3578
    ],
    "ekpeebhibhe": [
        3578
    ],
    "ernga": [
        3607
    ],
    "erngga": [
        3607
    ],
    "ekele": [
        3668
    ],
    "eastern parbate": [
        3676
    ],
    "eastern parbate kham": [
        3676
    ],
    "eastern kanjobal": [
        3697
    ],
    "eastern qanjobal": [
        3697
    ],
    "eulalia": [
        3697
    ],
    "east kewa": [
        3721
    ],
    "erave": [
        3726
    ],
    "ekaeku": [
        3753
    ],
    "eastern nahane": [
        3762
    ],
    "ekoka !xung": [
        3843
    ],
    "ekoka": [
        3843
    ],
    "ekoka-!xû": [
        3843
    ],
    "ekoko-!xû": [
        3843
    ],
    "ekoyo": [
        3857
    ],
    "eastern krahn": [
        3912
    ],
    "eastern kran": [
        3912
    ],
    "erorup": [
        3940
    ],
    "erenga": [
        3979
    ],
    "eastern katu": [
        4002
    ],
    "eastern kurmanji": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "ezdiki": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "egikuria": [
        4023
    ],
    "ekiguria": [
        4023
    ],
    "ekikuria": [
        4023
    ],
    "eoneo": [
        4055
    ],
    "ekwala": [
        4075
    ],
    "ekikwaya": [
        4132
    ],
    "enga-kyaka": [
        4134
    ],
    "ekokhola": [
        4173
    ],
    "eastern mbum": [
        4177
    ],
    "eshpanyol": [
        4189,
        4190,
        4191
    ],
    "eshpanyolit": [
        4189,
        4190,
        4191
    ],
    "espanyol": [
        4189,
        4190,
        4191
    ],
    "espanyolit": [
        4189,
        4190,
        4191
    ],
    "español sefardita": [
        4189,
        4190,
        4191
    ],
    "enyorot": [
        4247
    ],
    "enjorot": [
        4247
    ],
    "emoro": [
        4258
    ],
    "euronbba": [
        4356
    ],
    "ellyria": [
        4373
    ],
    "elu-kara": [
        4378
    ],
    "efate, north": [
        4388
    ],
    "east limba": [
        4393
    ],
    "eastern thai": [
        4439
    ],
    "elhomwe": [
        4453,
        5431
    ],
    "eastern lisu": [
        4471,
        4472
    ],
    "ende malay": [
        4486
    ],
    "ethur": [
        4511
    ],
    "epulu": [
        4544
    ],
    "epule": [
        4544
    ],
    "eleng": [
        4549
    ],
    "eastern lawa": [
        4552
    ],
    "esiluyana": [
        4563
    ],
    "eloxochitlán": [
        4571
    ],
    "eastern malinke": [
        4587,
        4588,
        4589
    ],
    "enna": [
        4594
    ],
    "enimaca": [
        4625
    ],
    "enimaga": [
        4625
    ],
    "eastern putla mixtec": [
        4629
    ],
    "eme-eme": [
        4646
    ],
    "embosi": [
        4674
    ],
    "embɔ́sí": [
        4674
    ],
    "ekokoma": [
        4723
    ],
    "ebiri": [
        4740
    ],
    "emakhua": [
        4747,
        8114
    ],
    "emakhuwa": [
        4747,
        8114,
        8123,
        8124
    ],
    "emeto": [
        4747
    ],
    "eastern magar": [
        4755
    ],
    "ebon": [
        4766
    ],
    "emakhuwa-emoniga": [
        4778
    ],
    "emoniga": [
        4778
    ],
    "esteban": [
        4792
    ],
    "eastern jamiltepec-chayuco mixtec": [
        4799
    ],
    "eastern mixtec": [
        4803
    ],
    "eastern mixe": [
        4810
    ],
    "eastern juxtlahuaca mixtec": [
        4815
    ],
    "ede-mɔkɔle": [
        4857
    ],
    "east makian": [
        4870
    ],
    "elwana": [
        4884
    ],
    "espiegle bay": [
        4885
    ],
    "espiegle": [
        4885
    ],
    "eastern miao": [
        4918,
        5139
    ],
    "emae": [
        4922
    ],
    "emai": [
        4922
    ],
    "emwae": [
        4922
    ],
    "eastern mnong": [
        4941
    ],
    "ebadidi": [
        4980
    ],
    "elseng": [
        5044
    ],
    "eastern ghao-xong": [
        5139
    ],
    "eastern west-hunan miao": [
        5139
    ],
    "eastern xiangxi miao": [
        5139
    ],
    "eklep": [
        5180
    ],
    "eastern mishmi": [
        5214,
        9068
    ],
    "esimbowe": [
        5219
    ],
    "eastern jamiltepec-san cristobal mixtec": [
        5224
    ],
    "erzya": [
        5250
    ],
    "erza-mordvin": [
        5250
    ],
    "erzia": [
        5250
    ],
    "erzya mordva": [
        5250
    ],
    "erzya mordvin": [
        5250
    ],
    "egum": [
        5251
    ],
    "emoa": [
        5253
    ],
    "en ningotsie": [
        5264
    ],
    "east central mixe": [
        5267
    ],
    "emela": [
        5317
    ],
    "ekuri": [
        5322
    ],
    "eastern pahadi": [
        5385,
        5386
    ],
    "eastern pahari": [
        5385,
        5386
    ],
    "eastern ngad'a": [
        5389
    ],
    "elkembey": [
        5395
    ],
    "el’kan beye": [
        5395
    ],
    "el’kan": [
        5395
    ],
    "elomwe": [
        5431
    ],
    "engwo": [
        5433
    ],
    "ekengoreme": [
        5435
    ],
    "engdewu": [
        5436
    ],
    "engungwel": [
        5444
    ],
    "eastern huasteca aztec": [
        5449
    ],
    "eastern huasteca nahuatl": [
        5449
    ],
    "ek nii": [
        5475
    ],
    "ek": [
        5475
    ],
    "eustatius": [
        5539
    ],
    "east nyala": [
        5546
    ],
    "east taa": [
        5576
    ],
    "edawapi": [
        5604
    ],
    "eastern nisu": [
        5634
    ],
    "ewage-notu": [
        5636
    ],
    "ekinyambo": [
        5638
    ],
    "eastern rengma": [
        5647
    ],
    "ede nago": [
        5652
    ],
    "ede nago, kura": [
        5653
    ],
    "eastern angami": [
        5669
    ],
    "eastern naxi": [
        5678
    ],
    "esakaji": [
        5711
    ],
    "eghiikoma": [
        5715
    ],
    "empeo": [
        5817
    ],
    "empui": [
        5817
    ],
    "efutop": [
        5847
    ],
    "ebkuo": [
        5887
    ],
    "ekpwo": [
        5887
    ],
    "east ambae": [
        5905
    ],
    "eudeve": [
        5946
    ],
    "elunchun": [
        5954
    ],
    "elema": [
        5956,
        7687
    ],
    "eochavante": [
        5984
    ],
    "euchavante": [
        5984
    ],
    "eastern highland otomi": [
        5987
    ],
    "eastern otomi": [
        5987
    ],
    "estado": [
        5991
    ],
    "estado de méxico otomi": [
        5991
    ],
    "eastern ojibwa": [
        5994
    ],
    "elfdalian": [
        6004
    ],
    "elvdalian": [
        6004
    ],
    "eastern panjabi": [
        6012,
        6013,
        6014,
        6015
    ],
    "eremagok": [
        6044
    ],
    "e’ñapa woromaipu": [
        6048
    ],
    "e’ñapa": [
        6048
    ],
    "e'ñapa woromaipu": [
        6048
    ],
    "eñapa": [
        6048
    ],
    "eye": [
        6048
    ],
    "eñepa": [
        6048
    ],
    "e’ñepa": [
        6048
    ],
    "ekipangwa": [
        6055
    ],
    "eastern pomo": [
        6090
    ],
    "eastern penan": [
        6107
    ],
    "enegua": [
        6155
    ],
    "eastern popoloca": [
        6251
    ],
    "eastern farsi": [
        6299
    ],
    "eastern afghan pashto": [
        6306
    ],
    "eshareh": [
        6309
    ],
    "enim": [
        6311
    ],
    "europeu": [
        6338
    ],
    "enrekang": [
        6349
    ],
    "endekan": [
        6349
    ],
    "endekan timur": [
        6349
    ],
    "ecuadorean quechua": [
        6401
    ],
    "ecuadorean": [
        6401
    ],
    "estero": [
        6410
    ],
    "eastern apurímac quechua": [
        6417
    ],
    "ecuador quichua": [
        6424
    ],
    "e-de": [
        6457
    ],
    "edeh": [
        6457
    ],
    "easter island": [
        6470
    ],
    "easter": [
        6470
    ],
    "emiliano-romagnolo": [
        6509
    ],
    "erigbaagtsá": [
        6533
    ],
    "erigpactsá": [
        6533
    ],
    "erigpaktsá": [
        6533
    ],
    "erikbaktsá": [
        6533
    ],
    "erikbatsá": [
        6533
    ],
    "erikpatsá": [
        6533
    ],
    "english romani": [
        6544
    ],
    "erempi": [
        6557
    ],
    "east toraja": [
        6581
    ],
    "eluosi": [
        6610,
        6612
    ],
    "erawa": [
        6641,
        6642
    ],
    "erewa": [
        6641,
        6642
    ],
    "e lokop": [
        6672
    ],
    "echisubia": [
        6709
    ],
    "esclave du nord": [
        6734,
        6735
    ],
    "east songhay": [
        6792
    ],
    "encabellao": [
        6797
    ],
    "eastern subanen": [
        6800
    ],
    "esahie": [
        6803
    ],
    "ehkili": [
        6857
    ],
    "epéna pedée": [
        6889
    ],
    "epéna": [
        6889
    ],
    "emberá chami": [
        6889
    ],
    "emberá del sur": [
        6889
    ],
    "emberá-saija": [
        6889
    ],
    "epena saija": [
        6889
    ],
    "epená": [
        6889
    ],
    "epená saija": [
        6889
    ],
    "epera pedede": [
        6889
    ],
    "eastern sámi": [
        6891
    ],
    "ep warwar anun dat": [
        6905
    ],
    "ep": [
        6905
    ],
    "eso": [
        7026
    ],
    "essono": [
        7143
    ],
    "española": [
        7144
    ],
    "eastern tatar": [
        7182
    ],
    "eshira": [
        7237
    ],
    "eastern tamang": [
        7308,
        7309
    ],
    "é": [
        7336
    ],
    "eastern tunebo": [
        7342
    ],
    "emberá-tadó": [
        7385
    ],
    "eastern teke": [
        7418
    ],
    "elgumi": [
        7421
    ],
    "etossio": [
        7421
    ],
    "emo'u xâne": [
        7425
    ],
    "emou": [
        7425
    ],
    "emo’u xâne": [
        7425
    ],
    "emo’u": [
        7425
    ],
    "etelena": [
        7425
    ],
    "eastern gorkha tamang": [
        7450
    ],
    "etakwani": [
        7539
    ],
    "etakwane": [
        7539
    ],
    "enenxet": [
        7592
    ],
    "emok-lik": [
        7639
    ],
    "east elema": [
        7687
    ],
    "east tarangan": [
        7704
    ],
    "east trangan": [
        7704
    ],
    "eastern lake purepecha": [
        7752
    ],
    "enggros": [
        7763
    ],
    "echitotela": [
        7766
    ],
    "esarn": [
        7772
    ],
    "evadi": [
        7805
    ],
    "ellice": [
        7808
    ],
    "ellicean": [
        7808
    ],
    "eastern tzutujil": [
        7881,
        7882
    ],
    "enggipiloe": [
        7927
    ],
    "ekpenmi": [
        7941
    ],
    "epinmi": [
        7941
    ],
    "east torres": [
        7950
    ],
    "enawené-nawé": [
        7973
    ],
    "eneuene-mare": [
        7973
    ],
    "edze": [
        7992
    ],
    "eru-eu-wau-wau": [
        8013
    ],
    "es-saare": [
        8020
    ],
    "eastern duka": [
        8024
    ],
    "eastern dukawa": [
        8024
    ],
    "et-hun": [
        8024
    ],
    "etulo": [
        8026
    ],
    "eturo": [
        8026
    ],
    "erap": [
        8034
    ],
    "ezeshio": [
        8094
    ],
    "east marsela": [
        8108
    ],
    "east masela": [
        8108
    ],
    "eastern franconian": [
        8109
    ],
    "echirima": [
        8114
    ],
    "emakhua eshirima": [
        8114
    ],
    "eshirima": [
        8114
    ],
    "emakhua exirima": [
        8114
    ],
    "exirima": [
        8114
    ],
    "emakhuwa echirima": [
        8114
    ],
    "en naxijen": [
        8117
    ],
    "emarendje": [
        8119
    ],
    "emakhuwa-makhuwana": [
        8123,
        8124
    ],
    "emakua": [
        8123,
        8124
    ],
    "enre naxinanda nguifi": [
        8126
    ],
    "enre": [
        8126
    ],
    "ebina": [
        8132,
        8934
    ],
    "ebuna": [
        8132,
        8934
    ],
    "esiriun": [
        8155
    ],
    "elpira": [
        8187
    ],
    "ealeba": [
        8218
    ],
    "epa": [
        8230
    ],
    "eik-me’anha": [
        8233
    ],
    "elken": [
        8236
    ],
    "enibura": [
        8252
    ],
    "eel": [
        8260
    ],
    "east uvea": [
        8265
    ],
    "east uvean": [
        8265
    ],
    "echiungu": [
        8366
    ],
    "european oirat": [
        8398,
        8399
    ],
    "european": [
        8398,
        8399
    ],
    "endangen": [
        8418
    ],
    "east sumba": [
        8424
    ],
    "east sumbanese": [
        8424
    ],
    "edomite": [
        8447
    ],
    "eblan": [
        8450
    ],
    "epi-olmec": [
        8455
    ],
    "elymian": [
        8529
    ],
    "emaka": [
        8532
    ],
    "eghap": [
        8536,
        8537
    ],
    "east mori": [
        8555
    ],
    "eastern karaboro": [
        8616
    ],
    "esaaka": [
        8638
    ],
    "esaka": [
        8638
    ],
    "eetha-eetha": [
        8651
    ],
    "eethee eethee": [
        8651
    ],
    "eethee": [
        8651
    ],
    "eethie-eethie": [
        8651
    ],
    "early tripuri": [
        8661
    ],
    "early": [
        8661
    ],
    "eruku bhasha": [
        8778
    ],
    "eruku": [
        8778
    ],
    "eastern yi": [
        8797
    ],
    "eneby": [
        8799
    ],
    "eastern lalu": [
        8809
    ],
    "e-xin yi": [
        8811
    ],
    "e-xin": [
        8811
    ],
    "eastern buyang": [
        8834,
        8898,
        8964
    ],
    "e’cun buyang": [
        8834
    ],
    "e’cun": [
        8834
    ],
    "east cape yupik": [
        8862
    ],
    "eyansi": [
        8867
    ],
    "eyanzi": [
        8867
    ],
    "ekhepho": [
        8884
    ],
    "euchee": [
        8921
    ],
    "ebәna": [
        8934
    ],
    "east yugur": [
        8941
    ],
    "eastern yogor": [
        8941
    ],
    "enger": [
        8941
    ],
    "enge’er": [
        8941
    ],
    "eramwir-rangu": [
        8959
    ],
    "eraweerung": [
        8959
    ],
    "erawiruck": [
        8959
    ],
    "e’ma": [
        8964
    ],
    "e'ma buyang": [
        8964
    ],
    "etla zapotec": [
        8973,
        9144
    ],
    "etla": [
        8973,
        9144
    ],
    "ejutla": [
        8974,
        9139
    ],
    "ekizanaki": [
        8980
    ],
    "east central tlacolula zapotec": [
        8991
    ],
    "east valley zapotec": [
        8991
    ],
    "eastern pochutla zapotec": [
        8992
    ],
    "east berawan": [
        8998
    ],
    "eastern hongshuihe zhuang": [
        9009
    ],
    "ekikinga": [
        9012
    ],
    "echidzindza": [
        9056
    ],
    "echijinja": [
        9056
    ],
    "echiziinza": [
        9056
    ],
    "echizinza": [
        9056
    ],
    "ecijinja": [
        9056
    ],
    "ecizinza": [
        9056
    ],
    "ekizinza": [
        9056
    ],
    "emfinu": [
        9086
    ],
    "eastern tlacolula zapotec": [
        9125
    ],
    "eastern sola de vega zapotec": [
        9131
    ],
    "eastern miahuatlán zapotec": [
        9132
    ],
    "el alto zapotec": [
        9135
    ],
    "eastern ocotlán zapotec": [
        9141
    ],
    "elotepec": [
        9160
    ],
    "elotepec zapotec": [
        9160
    ]
};
